import { useMutation } from '@tanstack/react-query'
import {
  SignwithDigitalDeviceClientRequest,
  SignwithDigitalDeviceClientResponse,
} from '../../../@types/digitalSignature/signWithDigitalDevice'
import { api } from '../../../Services/API'
import { useSignWithDigitalDeviceStore } from '../../../Stores/digitalSignature/useSignWithDigitalDeviceStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
const request = async (payload: SignwithDigitalDeviceClientRequest) => {
  const response = await api.post<SignwithDigitalDeviceClientResponse>(
    API_ROUTES.signWithDigitalDevice,
    payload,
  )
  return response.data
}
export const useSignWithDigitalDevice = () => {
  const { setSignWithDigitalDevice } = useSignWithDigitalDeviceStore()

  return useMutation({
    mutationFn: (payload: SignwithDigitalDeviceClientRequest) =>
      request(payload),
    onSuccess(data) {
      setSignWithDigitalDevice(data)
    },
  })
}
